export const accessoryApi = {
  // 初始化信息
  getInit: {
      method: 'post',
      api: 'admin/setting/getInit',
  },
  setInit: {
    method: 'post',
    api: 'admin/setting/setInit',
  },
  getInfo: {
    method: 'post',
    api: 'admin/common/getInfo',
  },
  uploadImg: {
    method: 'post',
    api: 'admin/setting/uploadImg',
  },
  uploadVideo: {
    method: 'post',
    api: 'admin/setting/uploadVideo',
  },
  getDataDoard: {
    method: 'post',
    api: 'admin/setting/getDataDoard',
  }
}
